import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    materialData: null,
    error: null,
    loading: false,
    insertData: null,
    updateData: null,
    deleteData: null,
    errorInsert: null,
    errorUpdate: null,
    errorDelete: null,
};

const materialSlice = createSlice({
    name: "material",
    initialState,
    reducers: {
        getDataAll: (state) => {
            state.loading = true;
        },
        getDataAllSuccess: (state, action) => {
            state.loading = false;
            state.materialData = action.payload;
            state.error = null;
        },
        getDataAllFail: (state, action) => {
            state.loading = false;
            state.materialData = null;
            state.error = action.payload;
        },
        addMaterial: (state) => {
            state.loading = true;
            state.insertData = null;
            state.errorInsert = null;
        },
        addMaterialSuccess: (state, action) => {
            state.loading = false;
            state.insertData = action.payload;
            state.errorInsert = null;
        },
        addMaterialFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
            state.insertData = null;
            state.errorInsert = action.payload;
        },
        updateMaterial: (state) => {
            state.loading = true;
        },
        updateMaterialSuccess: (state, action) => {
            state.loading = false;
            state.updateData = action.payload;
            state.error = null;
        },

        updateMaterialFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        deleteMaterial: (state) => {
            state.loading = true;
        },
        deleteMaterialSuccess: (state, action) => {
            state.loading = false;
            state.deleteData = action.payload;
            state.error = null;
        },
        deleteMaterialFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

        setDataNull: (state) => {
            state.error = null;
            state.insertData = null;
            state.updateData = null;
            state.deleteData = null;
            state.errorInsert = null;
            state.errorUpdate = null;
            state.errorDelete = null;
        },
    },
});

export const {
    getDataAll,
    getDataAllSuccess,
    getDataAllFail,
    addMaterial,
    addMaterialSuccess,
    addMaterialFail,
    updateMaterial,
    updateMaterialSuccess,
    updateMaterialFail,
    deleteMaterial,
    deleteMaterialSuccess,
    deleteMaterialFail,

    setDataNull,
} = materialSlice.actions;

export default materialSlice.reducer;
